"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutPropertiesLoose"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _button = _interopRequireDefault(require("../button"));

var _utils = require("../../utils");

var styles = {
  "sticky": "styles-sticky-3tUpM",
  "head-cell": "styles-head-cell-y0nGZ",
  "sortable": "styles-sortable-1hV1a",
  "asc": "styles-asc-1uDJb",
  "desc": "styles-desc-3B49S",
  "headCell": "styles-head-cell-y0nGZ"
};

/**
 * Simple table cell component for headings.
 */
var getSortOrder = function getSortOrder(order) {
  switch (order) {
    case 'asc':
      return ['ascending', 'Sorted ascending'];

    case 'desc':
      return ['descending', 'Sorted descending'];

    case null:
      return ['none', 'Not sortable'];

    default:
      return ['none', 'Not sorted'];
  }
};

var HeadCell = _react.default.forwardRef(function (_ref, ref) {
  var children = _ref.children,
      className = _ref.className,
      sticky = _ref.sticky,
      _ref$order = _ref.order,
      order = _ref$order === void 0 ? null : _ref$order,
      onClick = _ref.onClick,
      _ref$tag = _ref.tag,
      Tag = _ref$tag === void 0 ? 'th' : _ref$tag,
      restProps = (0, _objectWithoutPropertiesLoose2.default)(_ref, ["children", "className", "sticky", "order", "onClick", "tag"]);
  return _react.default.createElement(Tag, (0, _extends2.default)({
    className: _utils.classNames.use({
      sticky: sticky,
      headCell: true,
      sortable: order != null,
      asc: order === 'asc',
      desc: order === 'desc'
    }).from(styles).join(className),
    ref: ref,
    role: "columnheader",
    "aria-sort": getSortOrder(order)[0],
    scope: "col"
  }, restProps), _react.default.createElement(_button.default, {
    type: "button",
    tabIndex: 0,
    "aria-disabled": order === null,
    onClick: onClick
  }, children, _react.default.createElement("span", {
    className: "sr-only"
  }, getSortOrder(order)[1])));
});

HeadCell.propTypes = {
  sticky: _propTypes.default.bool,
  order: _propTypes.default.oneOf([null, 'any', 'asc', 'desc']),
  onClick: _propTypes.default.func
};
HeadCell.defaultProps = {
  order: null,
  sticky: false,
  onClick: undefined
};
var _default = HeadCell;
exports.default = _default;